import { render, staticRenderFns } from "./staHospital.vue?vue&type=template&id=c42ce2f6&scoped=true"
import script from "./staHospital.vue?vue&type=script&lang=js"
export * from "./staHospital.vue?vue&type=script&lang=js"
import style0 from "./staHospital.vue?vue&type=style&index=0&id=c42ce2f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42ce2f6",
  null
  
)

export default component.exports